import { render, staticRenderFns } from "./LayoutWithoutSidenav.vue?vue&type=template&id=60a65c4e&"
import script from "./LayoutWithoutSidenav.vue?vue&type=script&lang=js&"
export * from "./LayoutWithoutSidenav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a65c4e')) {
      api.createRecord('60a65c4e', component.options)
    } else {
      api.reload('60a65c4e', component.options)
    }
    module.hot.accept("./LayoutWithoutSidenav.vue?vue&type=template&id=60a65c4e&", function () {
      api.rerender('60a65c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/components/reviewer/LayoutWithoutSidenav.vue"
export default component.exports